import { useLocation } from "react-router-dom";
import { useHead } from "./useHead";

const DEFAULT_TITLE = "First Mover OS | Start your first business before the crowd";

// Title, description, canonical + og:url for the current path, and optional JSON-LD for the page.
export const useSeo = (title, description, jsonLd) => {
  const { pathname } = useLocation();
  useHead({
    title: title ? `${title} | First Mover OS` : DEFAULT_TITLE,
    description,
    path: pathname,
    jsonLd,
  });
};
